export enum PosAppEnum{
    APP_SESSION="authorization"
}

